'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _preact = require('preact');

var _preact2 = require('unistore/preact');

var _preactFela = require('preact-fela');

var _NavbarList = require('./NavbarList');

var _NavbarList2 = _interopRequireDefault(_NavbarList);

var _NavbarSerasaConsumidor = require('./NavbarSerasaConsumidor');

var _NavbarSerasaConsumidor2 = _interopRequireDefault(_NavbarSerasaConsumidor);

var _HeaderNotification = require('../Header/HeaderNotification');

var _HeaderNotification2 = _interopRequireDefault(_HeaderNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var wrapperStyle = function wrapperStyle() {
  return {
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  };
};

var Wrapper = (0, _preactFela.createComponent)(wrapperStyle);

exports.default = (0, _preact2.connect)('menus,heimdall,notification,brand,product,loggedIn,login,signUp')(function (props) {
  var inScroll = props.inScroll,
      menus = props.menus,
      config = props.config,
      heimdall = props.heimdall,
      goMenu = props.goMenu,
      notification = props.notification,
      brand = props.brand,
      product = props.product,
      loggedIn = props.loggedIn,
      login = props.login,
      signUp = props.signUp;


  return (0, _preact.h)(
    Wrapper,
    null,
    (0, _preact.h)(_NavbarList2.default, {
      inScroll: inScroll,
      menus: menus,
      config: config,
      goMenu: goMenu,
      login: login,
      signUp: signUp,
      clicktype: 'menu'
    }),
    loggedIn && notification.active && (0, _preact.h)(_HeaderNotification2.default, {
      inScroll: inScroll,
      config: config,
      brand: brand,
      product: product
    }),
    (0, _preact.h)(_NavbarSerasaConsumidor2.default, {
      inScroll: inScroll,
      hasMenus: menus && menus.length,
      heimdall: heimdall,
      config: config,
      login: login,
      signUp: signUp
    })
  );
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ecs/heimdall/build/components/Navbar/NavbarDesktop.js
// module id = 189
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38